/** Mensajes de handoff a humano: texto fijo del sistema, no corregibles vía guía. */
export function isFixedHandoffAgentMessage(m: {
  agentSource?: string | null;
  content?: string | null;
}): boolean {
  if (m.agentSource === 'handoff') return true;
  // Legado: el handoff se persistía como `rules` con el mensaje default del sistema.
  if (m.agentSource === 'rules') {
    const t = (m.content ?? '').toLowerCase();
    if (t.includes('redirigiendo tu conversación a un agente humano')) return true;
    if (t.includes('conectando con alguien del equipo para agendar')) return true;
  }
  return false;
}
